<elder-basic-pane-layout class="full p-0">
  <elder-pane class="bg-transparent">
    @let facilityIdTemplate = facilityId$ | async;
    <div class="layout-row gap-sm pt-md pl-md">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ 'context.facility' | translate }}</mat-label>
        <elder-select
          appFacilitySelect
          name="facility"
          valueAsId
          [value]="facilityIdTemplate"
          (valueChange)="facilityId = $event"
        ></elder-select>
      </mat-form-field>
    </div>

    @if (facilityIdTemplate) {
      <app-work-schedule-manager
        class="flex"
        [data]="data"
        [canAdd]="!!facilityIdTemplate"
        (create)="onCreate($event)"
        (deleteAll)="onDeleteAll($event)"
        (duplicate)="onDuplicate($event)"
        (save)="onSave($event)"
      ></app-work-schedule-manager>
    }
  </elder-pane>
</elder-basic-pane-layout>
